module.exports = __webpack_public_path__ + "static/media/bluetube2.861d017d.png";